import { Flag } from '../parsing-utils'
import MechanismFieldParser from './mechanism_field_parser'
import Formula from '../../models/mechanism/formula'

export default class FormulaParser extends MechanismFieldParser {
  constructor(context) {
    super(context, Formula.PRESETS, { saveBefore: true })
  }

  parseDefinition (text, definition) {
    const typeMatch = text.match(/\((.+?)\)$/)
    const type = typeMatch ? typeMatch[1] : 'any'
    const pattern = typeMatch ? text.replace(` (${type})`, '') : text
    return this.add(new Formula.ComplexFormula(pattern, type, definition))
  }
}
